import React from 'react';
import './Loading.css';
import loadingZeno from '../../assets/loading-zeno.mp4';

const Loading = () => {
  return (
    <div className="loading-component-container">
      <div className="loading-component-content">
        <div className="loading-zeno-video-container">
          <video 
            autoPlay 
            loop 
            muted 
            playsInline
            preload="metadata"
            className="loading-zeno-video"
          >
            <source src={loadingZeno} type="video/mp4" />
          </video>
        </div>
        <div className="loading-text-simple">
          Loading<span className="loading-dots-simple">...</span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
